export const getCasinoTicketIframeUrl = ticketTransactionId =>
	`https://www.cmxbonline.com/stage/gui/betonero/check_ticket/loader/?ticketid=${ticketTransactionId}`;
